const score = {
  createScore: async function(assignment, studentId, unitId, inputs, date) {
    const query = `
    mutation($assignment: String!, $date: Date, $value: String!, $studentId: Int!, $unitId: Int! ) {
      CreateScore(assignment: $assignment, date: $date, value: $value, studentId: $studentId, unitId: $unitId) {
        Score_Id
        Student_Unit_Id
      }
    }`;
    const variables = {
      assignment: assignment,
      date: date,
      value: JSON.stringify(inputs),
      studentId: parseInt(studentId),
      unitId: parseInt(unitId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.CreateScore;
    });
  },

  updateScore: async function(scoreId, assignment, unitId, inputs, date) {
    const query = `
    mutation($scoreId: Int!, $assignment: String!, $date: Date, $value: String!, $unitId: Int! ) {
      UpdateScore(scoreId: $scoreId, assignment: $assignment, date: $date, value: $value, unitId: $unitId) {
        Score_Id
        Student_Unit_Id
      }
    }`;
    const variables = {
      scoreId: parseInt(scoreId),
      assignment: assignment,
      date: date,
      value: JSON.stringify(inputs),
      unitId: parseInt(unitId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.UpdateScore;
    });
  },

  getStudentUnitScores: async function(studentUnitId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
            GetStudentUnitScores(studentUnitId: ` +
          parseInt(studentUnitId) +
          `){
              Score_Id
              Assignment
              Value
              Date
            }
          }`
      })
      .then(res => res.data.GetStudentUnitScores);
  },

  getScoresByStudentAndUnit: async function(studentId, unitId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
            GetScoresByStudentAndUnit(studentId: ` +
          parseInt(studentId) +
          `unitId: ` +
          parseInt(unitId) +
          `){
              Score_Id
              Assignment
              Value
              Date
            }
          }`
      })
      .then(res => res.data.GetScoresByStudentAndUnit);
  },

  deleteScore: async function(scoreId) {
    const query = `
    mutation($scoreId: Int!) {
      DELETESCORE(scoreId: $scoreId)
    }`;
    const variables = {
      scoreId: parseInt(scoreId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.DeleteScore;
    });
  }
};

export { score };
